const Breadcrumbs = {
  parts: [
    'breadcrumbs',
    'breadcrumbLink',
    'breadcrumbText',
    'breadcrumbSeparator'
  ],
  baseStyle: {
    breadcrumbs: {
      display: 'flex',
      alignItems: 'center',
      gap: '2', // 8px
      position: 'relative',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      maxWidth: '100%',
    },

    breadcrumbLink: {
      color: 'brandColors.greyscale80',
      fontFamily: 'aktiv-grotesk',
      fontSize: 'xs', // 12px
      fontWeight: '400',
      lineHeight: '120%',
      textDecoration: 'none',
      _hover: {
        textDecoration: 'underline',
      },
    },

    breadcrumbText: {
      color: 'brandColors.greyscale80',
      fontFamily: 'aktiv-grotesk',
      fontSize: 'xs', // 12px
      fontWeight: '400',
      lineHeight: '120%',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      maxWidth: '100%',
      _last: {
        color: 'brandColors.greyscale90',
        fontWeight: 500,
      },
    },

    breadcrumbSeparator: {
      color: 'brandColors.greyscale40',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
      px: '0.5', // spacing when using flex `gap` on the row (default variant)
    },
  },
  /**
   * No flex gap — spacing is controlled by separator padding only.
   * Use on job detail hero so arrow size/gap can diverge from site-wide breadcrumbs.
   */
  variants: {
    default: {},
    jobDetails: {
      breadcrumbs: {
        gap: 0,
      },
      breadcrumbSeparator: {
        color: 'brandColors.greyscale40',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        px: '6px',
        lineHeight: 0,
        '& svg': {
          width: '10px',
          height: '10px',
          display: 'block',
        },
      },
    },
    productDetail: {
      breadcrumbLink: {
        color: 'grayAlpha.80',
        fontFamily: 'body',
        fontSize: {base: '13px', lg: '12px'},
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '120%',
      },
      breadcrumbText: {
        color: 'grayAlpha.80',
        fontFamily: 'body',
        fontSize: {base: '13px', lg: '12px'},
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '120%',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        _last: {
          color: 'grayAlpha.80',
          fontWeight: 400,
        },
      },
      breadcrumbSeparator: {
        color: 'grayAlpha.80',
        fontSize: {base: '13px', lg: '12px'},
        fontWeight: 400,
        lineHeight: '120%',
      },
    },
  },
  defaultProps: {
    variant: 'default',
  },
};

export default Breadcrumbs;
